module.exports = __webpack_public_path__ + "static/img/wl_cc.dcd8de48.png";